<template>
	<div v-if="name" class="svg-icon">
		<Icon filled v-bind="$attrs" :name="`${prefix ? prefix : 'local'}:${name.toLocaleLowerCase()}`" />
	</div>
</template>
<script setup lang="ts">
const props = defineProps<{
	height?: number
	width?: number | string
	name: string
	color?: string
	prefix?: string
}>()

const heightPx = computed(() => {
	return props.height ? (typeof props.height === 'string' ? props.height : props.height + 'px') : props.width + 'px'
})

const widthPx = computed(() => {
	return props.width ? (typeof props.width === 'string' ? props.width : props.width + 'px') : props.height + 'px'
})
</script>
<style lang="scss">
.svg-icon {
	width: v-bind(widthPx);
	min-width: v-bind(widthPx);
	height: v-bind(heightPx);
	color: v-bind(color);
	font-size: v-bind(heightPx);

	.iconify {
		width: v-bind(widthPx);
		height: v-bind(heightPx);
	}
}
</style>
